export default {
  GET_ALL_CITIES: {
    pending: 'GET_ALL_CITIES/pending',
    fulfilled: 'GET_ALL_CITIES/fulfilled',
    rejected: 'GET_ALL_CITIES/rejected'
  },
  GET_CATEGORIES:{
    pending: 'GET_CATEGORIES/pending',
    fulfilled: 'GET_CATEGORIES/fulfilled',
    rejected: 'GET_CATEGORIES/rejected'
  },
  TOGGLE_SHOW_HOME_SEARCH: 'TOGGLE_SHOW_HOME_SEARCH',

  ON_MAIN_CLICK: 'ON_MAIN_CLICK',

  CONTACT_US: {
    pending: 'CONTACT_US/pending',
    fulfilled: 'CONTACT_US/fulfilled',
    rejected: 'CONTACT_US/rejected'
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/Main/ActioTypes.js